import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AccVentureAward, LanguageId } from '@interfaces';
import { AppService, StaticDataService } from '../../../../../../services';
import { DeliveryAreaService } from '../../../../delivery-area.service';
import { DeliveryOverviewService } from '../../../delivery-overview.service';
import { getSetup } from './grid/get-setup';

export interface DeliveryAward extends AccVentureAward {
	ventureName: string,
	accId: number,
	accName: string,
	facilitatorName: string | undefined,
	language: string,
	awardName: string,
	awardKind: string,
}


@Component({
	selector: 'delivery-all-awards-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './all-awards-view.part.html',
})
export class DeliveryAllAwardsViewPart {

	private readonly util = inject(UtilityService);
	private readonly dialogService = inject(DialogService);
	private readonly app = inject(AppService);
	private readonly staticDataService = inject(StaticDataService);
	private readonly pageService = inject(DeliveryOverviewService);
	private readonly areaService = inject(DeliveryAreaService);

	public setup = computed(() => getSetup(this.util, this.dialogService, this.areaService));

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public allAwards = computed<DeliveryAward[]>(() => {
		const data = this.areaService.deliveryData();

		if (!data) return [];

		const ventureById = this.util.array.toMap(data.allVentures, v => v.accVentureId);
		const accById = this.util.array.toMap(data.accelerators, a => a.accId);

		return data.allAwards.map(v => {
			const accVenture = ventureById[v.accVentureId]!;
			const acc = accById[accVenture.accId]!;
			return {
				...v,
				ventureName: accVenture.ventureName,
				accId: acc.accId,
				accName: acc.name,
				facilitatorName: this.app.getStaffNameById(acc.facilitatorStaffId),
				language: acc.languageId === LanguageId.Espanol ? 'Spanish' : 'English',
				awardName: this.staticDataService.awardnames.byId(v.awardNameId).name,
				awardKind: this.staticDataService.awardKinds.byId(v.awardKindId).name,
			};
		});
	});
}